import { GridApi, MenuItemDef } from "ag-grid-community";
import {
  IEditableBlock,
  returnEditInstrument,
} from "@/components/widgets/tradeFromScratch/helper/blockEditHelper";
import {
  loadFuturesReferenceData,
  loadTradeFromScratchReferenceData,
} from "@/components/widgets/tradeFromScratch/helper/tradeFromScratchHelper";
import featureFlagStore from "@/store/featureFlagStore";
import { startBlockEdit } from "@/store/draftLegsStoreACTIONS";
import { TicketInstrument } from "@/store/tradeFromScratchStore";

// LQC-3027 - shared by the row's pencil and the right-click menu, both behind tradeCreationEditBlocks.
export function canEditBlock(
  block: IEditableBlock | undefined,
  widgetId: string | undefined,
): boolean {
  if (!featureFlagStore.getState().tradeCreationEditBlocks) return false;
  return !!widgetId && !!returnEditInstrument(block);
}

// The edit draft is a new row, so it opens once the grid has it.
export function expandBlockEditRow(api: GridApi | undefined, draftId: string) {
  setTimeout(() => api?.getRowNode(draftId)?.setExpanded(true), 50);
}

export function openBlockEdit(
  widgetId: string,
  block: IEditableBlock,
  getAccessTokenSilently: Function,
  api?: GridApi,
) {
  // As "+ Leg" does: the edit's pickers and Risk need the bonds / futures (fetch-once).
  loadTradeFromScratchReferenceData(getAccessTokenSilently);
  if (returnEditInstrument(block) === TicketInstrument.Future) {
    loadFuturesReferenceData(getAccessTokenSilently);
  }
  const draftId = startBlockEdit(widgetId, block);
  if (draftId) expandBlockEditRow(api, draftId);
}

export function returnBlockEditContextMenuItems(
  block: IEditableBlock | undefined,
  widgetId: string | undefined,
  getAccessTokenSilently: Function,
  api?: GridApi,
): (MenuItemDef | string)[] {
  if (!block || !widgetId || !canEditBlock(block, widgetId)) return [];
  return [
    {
      name: "Edit Leg",
      action: () => openBlockEdit(widgetId, block, getAccessTokenSilently, api),
    },
    "separator",
  ];
}
